import React from "react";
import Link from "@JohnLewisPartnership/jl-design-system/dist/elements/link/Link";
import { ProfileOutlined } from '@JohnLewisPartnership/jl-design-system/dist/components/icons/ProfileOutlined'
import logo from "./john-lewis-partners-logotype.svg";
import styles from "./BPHeader.scss";
import Breadcrumb from "../breadcrumb/Breadcrumb";
import { ENV_VARS } from "../../../config";

const BPHeader = ({ content, userInfo, breadcrumbConfig }) => (
  <header className={styles.header}>
    <div className={styles.container}>
      <ul className={styles.skipLinks}>
        <li>
          <Link to="#main" isExternal className={styles.skipTo}>
            Skip to main content
          </Link>
        </li>
        <li>
          <Link to="#footer" isExternal className={styles.skipTo}>
            Skip to footer
          </Link>
        </li>
      </ul>

      <a href={content.browse_url} className={styles.logo}>
        <img src={logo} alt={content.logo_alt_b} />
      </a>

      <div className={styles["header-link--container"]}>
        <Breadcrumb data-testid="header-continue-shopping-link" className={styles["header-link--continue-shopping"]} text="Our services" {...breadcrumbConfig} />
      </div>

      <nav className={styles.nav}>
        <ul>
          <li>
            <Link isExternal aria-label={!!userInfo ? "Sign out" : "Sign in"} to={!!userInfo ? `${ENV_VARS.REACT_APP_BROWSE_HOST}/sign-out` : `${ENV_VARS.REACT_APP_BROWSE_HOST}/sign-in`}>
              {!!userInfo ? "Sign out" : "Sign in"}
              <ProfileOutlined  size="large" />
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  </header>
);

export default BPHeader;
